<!DOCTYPE html>
@if (showPaymentHoliday && !loader) {
  <ion-content>
    <div class="content-wrapper">
      <!-- titles wrapper -->
      <div class="upper-content-wrapper">
        <h1 class="page-title">{{'payment-holiday.payment_holiday' | translate}}</h1>
        <p class="tom-syndicate">{{latestOngoingSyndicateName}}</p>
        <img class="close-icon" (click)="dismiss()" src="assets/images/close-circle.png" alt="Close Icon"/>
      </div>
      <!-- card wrapper -->
      <div class="lower-content-wrapper">
        <div class="text-wrapper">
          <p class="emoji">🏖️</p>
          <p class="reason-heading"><span>{{'payment-holiday.weeks_free' | translate}}</span></p>
          <div class="reason-content">
            <p class="active-text">{{'payment-holiday.payment_break' | translate}} {{'payment-holiday.enjoy_services' | translate}}</p>
            <ul>
              <li><strong>{{'payment-holiday.entry' | translate}}</strong> {{'payment-holiday.usual_draw' | translate}}</li>
              <li>{{'payment-holiday.access_to' | translate}}<strong> {{'payment-holiday.instant_win' | translate}}</strong></li>
              <li><strong>{{'payment-holiday.reward_points' | translate}}</strong> {{'payment-holiday.check_winnings' | translate}}</li>
            </ul>
            <p class="active-text">{{'payment-holiday.way_of_saying' | translate}}<strong> {{'payment-holiday.thank_you' | translate}}</strong> {{ 'payment-holiday.for' | translate}} {{'payment-holiday.beign_part' | translate}} {{'payment-holiday.community' | translate}}
          </p>
        </div>
        <ion-button class="proceed-btn" (click)="takePaymentHoliday()">
          {{'payment-holiday.take_payment_holiday' | translate}}
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>
}

@if (!showPaymentHoliday && !loader) {
  <ion-content>
    <div class="content-wrapper">
      <!-- titles wrapper -->
      <div class="upper-content-wrapper">
        <h1 class="page-title">{{'payment-holiday.no_active_syndicate' | translate}}</h1>
        <img class="close-icon" (click)="dismiss()" src="assets/images/close-circle.png" alt="Close Icon"/>
      </div>
      <br/>
      <!-- card wrapper -->
      <div class="lower-content-wrapper">
        <div class="text-wrapper">
          <p class="emoji">🏖️</p>
          <p class="no-active-text"><strong>{{'payment-holiday.no_current_active' | translate}}</strong></p>
          <div class="reason-content">
            <p class="no-active-text"><strong>{{ 'payment-holiday.big_wins' | translate}}</strong></p>
            <ul>
              <li><strong>{{ 'payment-holiday.entry_lotteries' | translate}}</strong> </li>
              <li><strong>{{'payment-holiday.free_instant_win' | translate}}</strong></li>
              <li><strong>{{'payment-holiday.reward_points' | translate}}</strong> {{'payment-holiday.when_you_check' | translate}} {{'payment-holiday.your_winnings' | translate}}</li>
            </ul>
            <p class="active-text text-center">{{'payment-holiday.boost_chances' | translate}} {{'payment-holiday.win' | translate}}</p>
          </div>
          <ion-button class="proceed-btn" (click)="goToStore()">
            {{'payment-holiday.lets_go' | translate}}
          </ion-button>
        </div>
      </div>
    </div>
  </ion-content>
}
